export * from "./_entity/color-group/ATS_ColorGroupEditor/ATS_ColorGroupEditor.js";
//# sourceMappingURL=ats.js.map